module.exports = "<h2>Thank you</h2>\r\n<p>Your information has been submitted.</p>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna-frontend/js/views/autovalidate-default-success-msg.tpl.html
// module id = pfOC
// module chunks = 4